import { createWebSocketStore } from 'src/components/#services/helpers';
export const removeAccount = createWebSocketStore({
    auth: false,
    requestTemplate: {
        agent: 'auth',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'auth_removeAccount',
    },
});
export const getNickname = createWebSocketStore({
    auth: false,
    requestTemplate: {
        agent: 'user',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'profile_getUserNickname',
    },
});
